import { SVGProps } from 'react';



function BubbleIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 786.521 791.612"
            width="0.993em"
            height="1em"
            {...props}
        >
            <path
                d="M688.601 724.784c53.993-84.613-56.04-170.045-37.04-300.372s195.78-117.61 113.04-220.937-254.11-244.223-444-192.372-284.8 262.06-315.558 399.774 84.878 63.085 192.52 151.085 141.772 168.983 238.027 200.9c122.76 40.708 199.018 46.535 253.011-38.078z"
                fill="#1688f3"
                opacity={0.05}
            />
        </svg>
    );
}

export default BubbleIcon;
